import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SideMenu from './components/SideMenu';
import SearchModal from './components/SearchModal';
import CookieBanner from './components/CookieBanner';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import Article from './pages/Article';
import Category from './pages/Category';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import {
  MentionsLegales,
  PolitiqueConfidentialite,
  PolitiqueCookies,
  CGU,
} from './pages/LegalPages';
import { APropos, Contact } from './pages/AboutContact';
import NotFound from './pages/NotFound';

// Chrome = Header/Navbar/Footer wrapper. Hidden for /admin*.
const Chrome = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) return <>{children}</>;
  return (
    <>
      <Header onMenuClick={() => setMenuOpen(true)} onSearchClick={() => setSearchOpen(true)} />
      <Navbar />
      <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
      {children}
      <Footer />
      <CookieBanner />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-[#faf7f2] text-[#1a1414] min-h-screen">
        <BrowserRouter>
          <GoogleAnalytics />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              {/* Legal pages */}
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/cookies" element={<PolitiqueCookies />} />
              <Route path="/cgu" element={<CGU />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/contact" element={<Contact />} />
              {/* 404 catch-all — MUST be last */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Chrome>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
